import React from 'react';
import { makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { FORM_COLORS } from '../PublicationFormModal/constants';

const STEPS = ['Descargar plantilla', 'Subir archivo', 'Confirmar'];

const useStyles = makeStyles(() => ({
  bar: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24,
  },
  step: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
  },
  circle: {
    width: 26,
    height: 26,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 500,
    background: FORM_COLORS.bg,
    color: FORM_COLORS.textSecondary,
    border: `1.5px solid ${FORM_COLORS.border}`,
  },
  circleActive: {
    background: FORM_COLORS.pinkLight,
    color: FORM_COLORS.pink,
    border: `1.5px solid ${FORM_COLORS.pink}`,
  },
  circleDone: {
    background: FORM_COLORS.pink,
    color: '#fff',
    border: `1.5px solid ${FORM_COLORS.pink}`,
  },
  label: {
    fontSize: 11,
    color: FORM_COLORS.textSecondary,
  },
  labelActive: {
    color: FORM_COLORS.pink,
  },
  line: {
    flex: 1,
    height: 1,
    background: FORM_COLORS.border,
    margin: '0 8px 18px',
  },
  lineDone: {
    background: FORM_COLORS.pink,
  },
}));

interface ImportStepsBarProps {
  /** Paso actual (1 a 3). */
  currentStep: number;
}

export const ImportStepsBar = ({ currentStep }: ImportStepsBarProps) => {
  const classes = useStyles();

  return (
    <div className={classes.bar}>
      {STEPS.map((label, index) => {
        const stepNumber = index + 1;
        const isDone = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;
        return (
          <React.Fragment key={label}>
            <div className={classes.step}>
              <div
                className={`${classes.circle} ${isActive ? classes.circleActive : ''} ${
                  isDone ? classes.circleDone : ''
                }`}
              >
                {isDone ? <CheckIcon style={{ fontSize: 14 }} /> : stepNumber}
              </div>
              <span className={`${classes.label} ${isActive ? classes.labelActive : ''}`}>
                {label}
              </span>
            </div>
            {stepNumber < STEPS.length && (
              <div className={`${classes.line} ${isDone ? classes.lineDone : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
